import { Button, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import {
	addSingleTicketCategory,
	loadAllTicketCategory,
	updateTicketCategory,
} from "../../../../../redux/rtk/features/crm/ticketCategory/ticketCategorySlice";
import { useSelector } from "react-redux";

export default function CreateCrmTicketCategoryForm({ onClose, edit }) {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state.ticketCategory);

	const onFinish = async (values) => {
		const resp = await dispatch(edit?.id
			? updateTicketCategory({ id: edit?.id, values })
			: addSingleTicketCategory(values)
		);
		if (resp.payload.message === "success") {
			dispatch(loadAllTicketCategory());
			form.resetFields();
			onClose && onClose();
		}
	};
	const onCancel = () => {
		form.resetFields();
		onClose && onClose();
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
	};

	return (
		<Form
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			colon={false}
			layout='vertical'
			requiredMark={false}
			initialValues={edit?.id ? { ...edit?.values } : {}}
			form={form}>
			<Form.Item
				label={<span className='font-medium text-slate-700'>Post category name</span>}
				name='ticketCategoryName'
				rules={[{ required: true, message: "This is a required field." }]}>
				<Input size='large' placeholder='e.g. Events' />
			</Form.Item>

			<div className='flex items-center gap-3'>
				<Button size='large' onClick={onCancel} className='flex-1 rounded-xl'>
					Cancel
				</Button>
				<Button
					size='large'
					htmlType='submit'
					type='primary'
					loading={loading}
					className='cp-navy-btn flex-1 rounded-xl'>
					{edit?.id ? "Save changes" : "Create"}
				</Button>
			</div>
		</Form>
	);
}
